import { render, staticRenderFns } from "./UserInvoices.vue?vue&type=template&id=ab739062&scoped=true"
import script from "./UserInvoices.vue?vue&type=script&lang=js"
export * from "./UserInvoices.vue?vue&type=script&lang=js"
import style0 from "./UserInvoices.vue?vue&type=style&index=0&id=ab739062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab739062",
  null
  
)

export default component.exports